import React, { useState, useEffect } from "react";
import { client } from "../components/client";
import { motion } from "framer-motion";
import { transition1 } from "../transitions";
import Hero from "../components/Hero";
import { useNavigate } from "react-router-dom";

const WeCollective = () => {
  const [portraits, setPortraits] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const query = '*[_type == "portraits"]';

    client.fetch(query).then((data) => {
      setPortraits(data);
    });

    console.log(portraits);
  }, []);

  return (
    <>
      <motion.section
        initial={{ opacity: 0, y: "100%" }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: "100%" }}
        transition={transition1}
        className="overflow-hidden"
      >
        <Hero />
      </motion.section>
      <motion.section
        initial={{ opacity: 0, y: "100%" }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: "100%" }}
        transition={transition1}
        className="lg:section overflow-hidden"
      >
        <div className="container mx-auto">
          <div className="lg:flex flex-col lg:flex-row lg:justify-between justify-center md:mt-20">
            <div className="lg:flex flex-col">
              <div className="px-12 pt-4 pb-10 lg:pt-0 lg:p-0 flex flex-col lg:items-start items-center lg:mr-52">
                <div className="lg:h2 h3 justify-center">
                  Mission <br />
                </div>
                <hr className="border-t border-2 border-black w-full lg:my-6 mt-0 mb-4 lg:mb-6" />

                <div
                  onClick={() => navigate("/about")}
                  className=" border-2 border-black hover:scale-110 hover:bg-zinc-900 hover:text-white w-fit p-4 hover:cursor-pointer"
                >
                  View Board
                </div>
              </div>
            </div>

            <div className="lg:flex-2 md:p-0">
              <div className="px-10 lg:text-left lg:text-justify text-center">
                <span className="font-extrabold">
                  <span className="float-left mr-2 text-8xl font-bold">M</span>
                  undus Axis
                </span>{" "}
                Cartographies of Flux is a global platform dedicated to
                fostering decolonial art practices, cultural diversity, and the
                radical transformation of knowledge systems. Our mission is to
                create a decentralized space where artists, thinkers, cultural
                workers, and communities engage in ongoing processes of
                reclaiming, reconfiguring, and remapping power. We operate
                across geographies and disciplines, rooted in the principles of
                horizontal learning, mutual accountability, and earth-centered
                urgency. As an organization emerging from the Global South and
                extending to the Global North, we prioritize Indigenous
                knowledge, ecological wisdom, and trans-feminist values that
                reject the top-down, colonial structures of learning and
                engagement. Our work challenges the dominant, extractive
                systems—colonial, capitalist, patriarchal, and ecocidal—and
                seeks to dismantle these structures through radical imagination,
                cultural intervention, and artistic expression. <br /> <br />
                In a world in flux, we engage in the continuous flow of
                transformation, embracing the fluidity of identities, histories,
                and struggles. Our projects—spanning artistic creation,
                educational initiatives, and community-based interventions—are
                designed to cultivate spaces where marginalized, racialized,
                exiled, and feminized voices are amplified, and where new forms
                of care, and justice are shaped and practiced. <br /> <br />
                We build from intergenerational memory, cultural rupture, and
                insurgent knowledge, recognizing that our work is not about
                representing or reforming, but about rerouting power, forging
                new cultural cartographies, and fostering global unity that
                crosses borders and intersects diverse struggles. Mundus Axis:
                Cartographies of Flux stands as a living network of
                transformation—a space where art, thought, and action converge
                to create a world rooted in plurality, justice, and radical
                care, and where the transformation of society is viewed as an
                ever-evolving, fluid process of reclamation and remaking.
                Through our platform, we are not only constructing new cultural
                futures but inviting people from around the world to interact,
                create, and transform together in this shared journey towards a
                reconciled, decolonized, and renewed planet.
              </div>
            </div>
          </div>
        </div>
      </motion.section>
    </>
  );
};

export default WeCollective;
